import { Tooltip, Picture } from '@ui';
import { observer } from 'mobx-react';
import type { FC, MouseEventHandler, ReactNode } from 'react';
import icons from '@icons';
import './index.scss';

const {
  bonus: { white: bonusWhite }
} = icons.Outline;

interface ProductBuyBtnsProps {
  isDesktop?: boolean;
  productCount: number;
  addProductToCart: MouseEventHandler;
  decreaseProductInCart: MouseEventHandler;
  MobileComp: ReactNode;
  isShowLongBuyBtn?: boolean;
  isShowMinus?: boolean;
  isPreOrder?: string;
  isDigital?: boolean;
}

const ProductBuyBtns: FC<ProductBuyBtnsProps> = observer(
  ({
    isDesktop,
    productCount,
    addProductToCart,
    decreaseProductInCart,
    MobileComp,
    isShowLongBuyBtn,
    isShowMinus,
    isPreOrder,
    isDigital
  }) => {
    const notZero = productCount !== undefined && productCount > 0;
    if (isShowLongBuyBtn) {
      return (
        <div className={'ProductBuyBtns ProductBuyBtns--long'}>
          {notZero ? (
            <>
              <button
                // disabled={isMinusDisabled}
                className='ProductBuyBtns__minus'
                onClick={decreaseProductInCart}
              />
              <div className='ProductBuyBtns__count'>{productCount}</div>
              <button
                className={`ProductBuyBtns__plus${
                  isPreOrder ? ' ProductBuyBtns__plus--preOrder' : ''
                }`}
                onClick={addProductToCart}
              />
            </>
          ) : (
            <button className='ProductBuyBtns__buy' onClick={addProductToCart}>
              Купить
            </button>
          )}
        </div>
      );
    }
    return (
      <div className={`ProductBuyBtns${notZero ? ' ProductBuyBtns--fw' : ''}`}>
        {notZero && (
          <>
            {isShowMinus && (
              <button
                className='ProductBuyBtns__minus'
                onClick={decreaseProductInCart}
              />
            )}
            {isDesktop ? (
              <div className='ProductBuyBtns__count'>{productCount}</div>
            ) : (
              MobileComp
            )}
          </>
        )}

        {!notZero && isPreOrder ? (
          <Tooltip
            on={['hover', 'focus']}
            offsetY={20}
            positionImp='top right'
            className='ProductBuyBtns__plus--tooltip'
            arrow
            tooltipText={`Предзаказ на ${isPreOrder}`}
          >
            <div
              className={`ProductBuyBtns__plus${
                isPreOrder ? ' ProductBuyBtns__plus--preOrder' : ''
              }`}
              onClick={addProductToCart}
            />
          </Tooltip>
        ) : (
          <div
            className={
              isDigital
                ? 'ProductBuyBtns__digital'
                : `ProductBuyBtns__plus${
                    isPreOrder ? ' ProductBuyBtns__plus--preOrder' : ''
                  }`
            }
            onClick={addProductToCart}
          >
            {isDigital && (
              <Picture icon={bonusWhite} height={isDesktop ? '24' : '16'} />
            )}
          </div>
        )}
      </div>
    );
  }
);

export default ProductBuyBtns;
